import React, { useState, useEffect } from 'react';
import {useLocation, useParams} from 'react-router-dom';
import InfoPanel from "../components/pages-component/infoPanel";
import InfoPicture from "../components/pages-component/infoPicture";
import HeaderImage from "../components/pages-component/headerImage";
import {api} from "../services";
import LoopTitle from "../components/pages-component/loopTitle";
import MediaInfoCard from "../components/pages-component/mediaInfoCard";
import ContactCard from "../components/pages-component/contactCard";
import DataEntry from "./dataEntry";
import '../css/App.css'
import NumericCard from "../components/pages-component/numericCard";
import RoadMap from "../components/pages-component/roadMap";
import {useLocalization} from "../context/localization";
import FormMessage from "../components/pages-component/formMessage";
import PdfLibrary from "../components/pages-component/pdfLibrary";

const PagesContainer = () => {
    const [pageData, setPageData] = useState(null);
    const [dataEntries, setDataEntries] = useState(null);
    const [pdfLibraries, setPdfLibraries] = useState(null);

    
    const { language } = useLocalization();
    let { slug } = useParams();
    const location = useLocation();

    useEffect(() => {
        const fetchData = async () => {
            const result = await api.general.getPages(language);
            const pages = result.data.data;
            
            // Normalize the slug for home page handling
            let normalizedSlug = slug == null || slug === '' ? '/' : `/${slug}`;

            const currentPage = pages.find((page) => {
                return page.attributes.slug === normalizedSlug;
            });
            
            
            if (currentPage) {
                setPageData(currentPage.attributes.pages);

                const entriesResponse = await api.general.getEntries(language, currentPage.id);

                const pdfLibraryResponse = await api.general.getLibrary();

                if (entriesResponse.data.data.length > 0 && entriesResponse.data.data[0].attributes.dataEntries) {
                    setDataEntries(entriesResponse.data.data[0].attributes.dataEntries);
                }
                
                if (pdfLibraryResponse.data.data.length > 0 && pdfLibraryResponse.data.data[0].attributes.library &&
                    pdfLibraryResponse.data.data[0].attributes.page.data.attributes.slug === normalizedSlug )
                {
                    setPdfLibraries(pdfLibraryResponse.data.data[0].attributes.library);
                }
            }
        };

        fetchData();
    }, [slug, language]);
    

    useEffect(() => {
        if (pageData) {
            window.location.reload(); 
        }
    }, [language,slug]);

    useEffect(() => {
        setDataEntries(null);
        setPdfLibraries(null);

    }, [location]);

    if (!pageData) {
        return <div>Loading...</div>;
    }
    

    return (
        <div className="component-container">
            {pageData?.map((component, index) => {
                switch (component.__component) {
                    case 'pages-component.info-panel':
                        return <InfoPanel key={index} title={component.title} description={component.description}/>;
                    case 'pages-component.info-picture':
                        return <InfoPicture key={index} media={component.media?.data}/>;
                    case 'pages-component.header-image':
                        return <HeaderImage key={index} data={component}/>;
                    case 'pages-component.loop-title':
                        return <LoopTitle key={index} data={component}/>;
                    case 'pages-component.media-info-card':
                        return <MediaInfoCard key={index} data={component}/>;
                    case 'pages-component.contact-card':
                        return <ContactCard key={index} data={component}/>;
                    case 'pages-component.numeric-card':
                        return <NumericCard data={component}/>;
                    case 'pages-component.road-map':
                        return <RoadMap data={component}/>;
                    case 'pages-component.form':
                        return <FormMessage data={component}/>;
                   
                         
                    default:
                        return null;
                }
            })}
            {dataEntries && <DataEntry data={dataEntries}/>}
            {pdfLibraries && <PdfLibrary data={pdfLibraries}/>}

        </div>
    );
};

export default PagesContainer;
